import { render, staticRenderFns } from "./PersonDepartureCard.vue?vue&type=template&id=ed1b0c18"
import script from "./PersonDepartureCard.vue?vue&type=script&lang=js"
export * from "./PersonDepartureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports